import { BaseProductWithChildren, ComponentWithContextProps } from '@greystar/ui';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

type CommunityCardRowProps = ComponentWithContextProps & {
  fields: {
    title: Field<string>;
    heading: Field<string>;
    bodyCopy: Field<string>;
    masterIds?: { name: string }[];
  };
  properties: BaseProductWithChildren[];
};

export default CommunityCardRowProps;
